<div class="kcs-card">
  <p-toast></p-toast>
  <div class="d-flex flex-row">
    <h5>{{ 'profile.title' | translate }}</h5>
  </div>
  <p-divider />
  @if(user){
    <div class="user-profile-container">
      <!-- Header Section -->
      <div class="profile-header-card">
        <div class="profile-header">
          <div class="avatar-section">
            <div class="avatar-edit-wrap">
              @if (user.avatar) {
                <img [src]="user.avatar" alt="avatar" class="profile-avatar-img" />
              } @else {
                <p-avatar [label]="configService.getUsernameInitials()" size="xlarge" class="profile-avatar" shape="circle" [style]="{ background: 'var(--kcs-primary)', color: 'var(--kcs-primary-text)' }"> </p-avatar>
              }
              <button type="button" class="avatar-edit-btn" [disabled]="avatarUploading" (click)="avatarInput.click()" title="{{ 'Cambia immagine profilo' | translate }}">
                <i class="pi" [ngClass]="avatarUploading ? 'pi-spin pi-spinner' : 'pi-camera'" aria-hidden="true"></i>
              </button>
              @if (user.avatar && !avatarUploading) {
                <button type="button" class="avatar-remove-btn" (click)="removeAvatar()" title="{{ 'Rimuovi immagine profilo' | translate }}">
                  <i class="pi pi-times" aria-hidden="true"></i>
                </button>
              }
              <input type="file" hidden accept="image/*" #avatarInput (change)="onAvatarSelected($event)" />
            </div>
          </div>

          <div class="profile-info">
            <div class="name-section">
              <h2 class="profile-name">{{ user.usr_firstname }} {{ user.usr_lastname }}</h2>
              <span class="username">&#64;{{ user.usr_displayname }}</span>
            </div>

            <div class="profile-stats">
              <div class="stat-item">
                <span class="stat-number">{{ getActiveRolesCount() }}</span>
                <span class="stat-label">{{ 'profile.roles' | translate }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">{{ getActivePortalsCount() }}</span>
                <span class="stat-label">{{ 'profile.portals' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="profile-actions d-flex gap-2">
            <p-button [label]="isEditMode ? 'Salva' : 'Modifica'" [icon]="isEditMode ? 'pi pi-check' : 'pi pi-pencil'" size="small" [loading]="savingProfile" (onClick)="toggleEditMode()" [severity]="isEditMode ? 'success' : 'secondary'" [outlined]="!isEditMode"> </p-button>
            <p-button *ngIf="isEditMode" label="Annulla" icon="pi pi-times" size="small" severity="secondary" [text]="true" (onClick)="cancelEdit()"> </p-button>
          </div>
      </div>
    </div>

    <!-- Tabbed Content -->
    <p-tabs [value]="0" class="profile-tabs">
      <p-tablist>
        <p-tab [value]="0"><i class="pi pi-user" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.profile-tab' | translate }}</p-tab>
        <p-tab [value]="1"><i class="pi pi-users" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.role-tab' | translate }}</p-tab>
        <p-tab [value]="2"><i class="pi pi-globe" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.portals-tab' | translate }}</p-tab>
        <p-tab [value]="3"><i class="pi pi-cog" style="margin-right: 0.5rem" aria-hidden="true"></i>{{ 'profile.settings.tab.settings-tab' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <!-- Personal Information Tab -->
        <p-tabpanel [value]="0">
          <p-card>
            <div class="form-grid">
              <div class="form-row">
                <div class="form-field">
                  <label for="firstName">{{ 'profile.firstname' | translate }}</label>
                  <input id="firstName" type="text" pInputText [(ngModel)]="editableUser.usr_firstname" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
                <div class="form-field">
                  <label for="lastName">{{ 'profile.lastname' | translate }}</label>
                  <input id="lastName" type="text" pInputText [(ngModel)]="editableUser.usr_lastname" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <!-- E' il nome mostrato nell'intestazione: viene salvato, quindi dev'essere modificabile -->
                  <label for="displayName">Nome da visualizzare</label>
                  <input id="displayName" type="text" pInputText [(ngModel)]="editableUser.usr_displayname" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label for="email">{{ 'profile.email' | translate }}</label>
                  <!-- La mail e' un'identita' di accesso: non si cambia da qui senza verifica -->
                  <input id="email" type="email" pInputText [(ngModel)]="editableUser.usr_mail" [readonly]="true" class="readonly" />
                </div>
                <div class="form-field">
                  <label for="phone">{{ 'profile.phone' | translate }}</label>
                  <div class="d-flex gap-2 align-items-center">
                    <input id="phone" type="tel" pInputText class="flex-grow-1" placeholder="+39..." [(ngModel)]="editableUser.usr_phone" [readonly]="phoneTokenSent" [class.readonly]="phoneTokenSent" />
                    @if (phoneVerified) {
                      <p-tag severity="success" icon="pi pi-check" value="Verificato"></p-tag>
                    } @else {
                      <p-button label="Verifica" size="small" icon="pi pi-mobile" [outlined]="true" severity="secondary" [loading]="phoneSending" (onClick)="sendPhoneToken()"></p-button>
                    }
                  </div>
                  @if (phoneTokenSent && !phoneVerified) {
                    <div class="d-flex gap-2 align-items-center mt-2">
                      <input type="text" pInputText inputmode="numeric" maxlength="6" placeholder="Codice ricevuto via SMS" [(ngModel)]="phoneOtp" />
                      <p-button label="Conferma" size="small" icon="pi pi-check" [loading]="phoneChecking" (onClick)="checkPhoneToken()"></p-button>
                      <p-button label="Annulla" size="small" severity="secondary" [text]="true" (onClick)="cancelPhoneVerification()"></p-button>
                    </div>
                  }
                </div>
              </div>

              <!--div class="form-row">
              <div class="form-field">
                <label for="department">Department</label>
                <input id="department" type="text" pInputText [(ngModel)]="editableUser.department" [readonly]="!isEditMode" [class.readonly]="!isEditMode" />
              </div>
            </div-->
          </div>
        </p-card>
      </p-tabpanel>

      <!-- Roles Tab -->
      <p-tabpanel [value]="1">
        <p-card>
          <div class="roles-section">
            <h4>{{ 'profile.assigned_roles' | translate }}</h4>
            <p class="section-description">{{ 'profile.assigned_roles.description' | translate }}</p>

            <div class="roles-grid">
              @for (role of assignedRoles; track role) {
                <div class="role-card" [class.active]="role.rl_isChecked">
                  <div class="role-header">
                    <div>
                      <h5>{{ role.rl_name }}</h5>
                      <p-tag [value]="role.rl_type" [severity]="getRoleSeverity(role.rl_type)" class="role-type-tag"> </p-tag>
                    </div>
                  </div>
                  <p class="role-description">{{ role.rl_description }}</p>
                  <div class="role-meta">
                    <small>{{ 'profile.assigned_roles.role_id' | translate }}: {{ role.rl_id }}</small>
                  </div>
                </div>
              }
            </div>

            <div class="roles-summary">
              <div class="summary-item">
                <span class="summary-label">{{ 'profile.assigned_roles.active_roles' | translate }}:</span>
                <p-badge [value]="getActiveRolesCount()" severity="success"></p-badge>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabpanel>

      <!-- Portals Tab -->
      <p-tabpanel [value]="2">
        <p-card>
          <div class="portals-section">
            <h4>{{ 'profile.assigned_portals' | translate }}</h4>
            <p class="section-description">{{ 'profile.assigned_portals.description' | translate }}</p>

            <p-table [value]="assignedPortals || []" [paginator]="true" [rows]="5" class="portals-table" responsiveLayout="scroll">
              <ng-template #header>
                <tr>
                  <th>{{ 'profile.assigned_portals.table.portal' | translate }}</th>
                  <th>{{ 'profile.assigned_portals.table.description' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template #body let-portal>
                <tr>
                  <td>
                    <div class="portal-info">
                      <div class="portal-icon">
                        <i class="pi pi-globe"></i>
                      </div>
                      <div>
                        <small class="portal-meta">ID: {{ portal.pt_id }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="portal-description" [pTooltip]="portal.pt_descrizione" tooltipPosition="top"> {{ portal.pt_descrizione | slice : 0 : 50 }}{{ portal.pt_descrizione.length > 50 ? '...' : '' }} </span>
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="2" class="text-center">{{ 'profile.assigned_portals.table.noportal' | translate }}</td>
                </tr>
              </ng-template>
            </p-table>

            <div class="portals-summary">
              <div class="summary-grid">
                <div class="summary-card">
                  <h5>{{ 'profile.assigned_portals.active_portals' | translate }}</h5>
                  <span class="big-number">{{ getActivePortalsCount() }}</span>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabpanel>

      <!-- Settings Tab -->
      <p-tabpanel [value]="3">
        <p-card>
          <div class="settings-section">
            <div class="notify-head">
              <div class="notify-head-text">
                <h4>{{ 'profile.notify.title' | translate }}</h4>
                <p class="section-description mb-0">{{ 'profile.notify.description' | translate }}</p>
              </div>
              <div class="notify-legend">
                <span class="notify-legend-item"><i class="pi pi-envelope" aria-hidden="true"></i>{{ 'profile.notify.channel.email' | translate }}</span>
                <span class="notify-legend-item"><i class="pi pi-bell" aria-hidden="true"></i>{{ 'profile.notify.channel.portal' | translate }}</span>
                <span class="notify-legend-item"><i class="pi pi-ban" aria-hidden="true"></i>{{ 'profile.notify.channel.none' | translate }}</span>
              </div>
            </div>

            @if (mailSettingsByCategory.length === 0) {
              <div class="notify-empty">
                <i class="pi pi-bell-slash" aria-hidden="true"></i>
                <span>{{ 'profile.notify.empty' | translate }}</span>
              </div>
            }

            @if (mailSettingsByCategory.length > 0) {
              <div class="notify-search">
                <i class="pi pi-search" aria-hidden="true"></i>
                <input type="text" class="kcs-inputtext kcs-component" [(ngModel)]="mailSearch" [placeholder]="'label.mail.lista.cerca' | translate" />
                @if (mailSearch) {
                  <button type="button" class="notify-search-clear" (click)="clearMailSearch()" aria-label="clear"><i class="pi pi-times" aria-hidden="true"></i></button>
                }
              </div>
            }

            @for (group of filteredMailSettingsByCategory; track group.category) {
              <p-panel [toggleable]="true" class="notify-panel">
                <ng-template #header>
                  <div class="notify-panel-head">
                    <span class="notify-cat-icon"><i [class]="categoryIcon(group.category)" aria-hidden="true"></i></span>
                    <span class="notify-cat-name">{{ categoryLabel(group.category) }}</span>
                    <p-badge [value]="group.items.length" severity="secondary"></p-badge>
                  </div>
                </ng-template>
                <ng-template #icons>
                  <div class="notify-bulk" (click)="$event.stopPropagation()">
                    <button pButton iconOnly type="button" class="p-button-rounded p-button-text notify-bulk-btn" [pTooltip]="'profile.notify.channel.email' | translate" tooltipPosition="top" (click)="setCategoryChannel(group, 'email')"><i class="p-button-icon pi pi-envelope"></i></button>
                    <button pButton iconOnly type="button" class="p-button-rounded p-button-text notify-bulk-btn" [pTooltip]="'profile.notify.channel.portal' | translate" tooltipPosition="top" (click)="setCategoryChannel(group, 'portal')"><i class="p-button-icon pi pi-bell"></i></button>
                    <button pButton iconOnly type="button" class="p-button-rounded p-button-text notify-bulk-btn" [pTooltip]="'profile.notify.channel.none' | translate" tooltipPosition="top" (click)="setCategoryChannel(group, 'none')"><i class="p-button-icon pi pi-ban"></i></button>
                  </div>
                </ng-template>

                @for (item of group.items; track item.umst_id) {
                  <div class="notify-pref-row" [class.is-off]="item.effective_channel === 'none'">
                    <div class="notify-pref-label">
                      <i [class]="channelIcon(item.effective_channel)" class="notify-row-state" [attr.data-ch]="item.effective_channel" aria-hidden="true"></i>
                      <span>{{ item.umst_desc }}</span>
                    </div>
                    <p-selectbutton [options]="channelOptions" [(ngModel)]="item.effective_channel" optionValue="value" [allowEmpty]="false" class="notify-channel-select">
                      <ng-template let-opt #item>
                        <i [class]="opt.icon" aria-hidden="true"></i>
                        <span class="ms-1 notify-opt-label">{{ opt.label | translate }}</span>
                      </ng-template>
                    </p-selectbutton>
                  </div>
                }
              </p-panel>
            }

            @if (mailSettingsByCategory.length > 0 && filteredMailSettingsByCategory.length === 0) {
              <div class="notify-empty">
                <i class="pi pi-search" aria-hidden="true"></i>
                <span>{{ 'label.rapportini.dialog.nessun_risultato' | translate }}</span>
              </div>
            }

            @if (mailSettingsByCategory.length > 0) {
              <div class="notify-savebar">
                <p-button [label]="'profile.notify.save' | translate" size="small" icon="pi pi-save" [loading]="savingMailSettings" [disabled]="!mailSettingsDirty" (onClick)="saveMailSettings()"></p-button>
              </div>
            }

            <p-divider></p-divider>

            <div class="account-info">
              <h4>{{ 'profile.settings.preferences.account_Information' | translate }}</h4>
              <div class="info-item">
                <span class="label">{{ 'profile.settings.preferences.account_Information.user_id' | translate }}:</span>
                <p-badge [value]="user.usr_id.toString()"></p-badge>
              </div>
              <div class="info-item">
                <span class="label">Username:</span>
                <span class="value">{{ user.usr_username }}</span>
              </div>
            </div>

            <p-divider></p-divider>

            <div class="account-info">
              <h4>Eliminazione account</h4>
              <p class="section-description">Puoi richiedere l'eliminazione del tuo account e dei dati personali associati.</p>
              <p-button label="Richiedi eliminazione account" size="small" severity="danger" [outlined]="true" icon="pi pi-trash" (onClick)="goToAccountDeletion()"></p-button>
            </div>
          </div>
        </p-card>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

}
</div>
